import Breadcrumbs from 'components/Common/Breadcrumb'
import { Pagination } from 'components/Common/Pagination'
import React, { useCallback, useMemo, useState } from 'react'
import { Search } from 'react-bootstrap-table2-toolkit'
import MetaTags from 'react-meta-tags'
import { useQuery } from 'react-query'
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable
} from 'react-table'
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
  UncontrolledDropdown
} from 'reactstrap'
import { fetchClients } from '../../core/http/fetchClients'
import { AwardModal } from './modals/AwardModal'
import { ConfigsModal } from './modals/ConfigsModal/'
import { LotteriesModal } from './modals/LotteriesModal/'
import { NewClientModal } from './modals/NewClientModal/'
import { PaymentModal } from './modals/PaymentModal'
import { ProfileModal } from './modals/ProfileModal'
import { UsersModal } from './modals/UsersModal'

export function Clients() {
  const { SearchBar } = Search

  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false)
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false)
  const [isLotteriesModalOpen, setIsLotteriesModalOpen] = useState(false)
  const [isAwardModalOpen, setIsAwardModalOpen] = useState(false)
  const [isUsersModalOpen, setIsUsersModalOpen] = useState(false)
  const [isNewClientModalOpen, setIsNewClientModalOpen] = useState(false)
  const [isConfigsModalOpen, setIsConfigsModalOpen] = useState(false)

  const [client, setClient] = useState(null)

  const { data, isSuccess, isLoading } = useQuery(['clients'], fetchClients, {
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5 // 5 minutes
  })

  const clients = useMemo(() => {
    return isSuccess ? data : []
  }, [isSuccess, data])

  const handleCallModalAction = useCallback(
    (modal, props) => {
      if (props) {
        const [clientData] = clients.filter(
          client => client.id === props.cell.row.values.id
        )
        setClient(clientData)
      }

      switch (modal) {
        case 'Profile':
          setIsProfileModalOpen(currentState => !currentState)
          break

        case 'Payment':
          setIsPaymentModalOpen(currentState => !currentState)
          break

        case 'Lotteries':
          setIsLotteriesModalOpen(currentState => !currentState)
          break

        case 'Award':
          setIsAwardModalOpen(currentState => !currentState)
          break

        case 'Users':
          setIsUsersModalOpen(currentState => !currentState)
          break

        case 'NewClient':
          setIsNewClientModalOpen(currentState => !currentState)
          break

        case 'Configs':
          setIsConfigsModalOpen(currentState => !currentState)
      }
    },
    [clients]
  )

  const columns = useMemo(() => {
    return [
      {
        accessor: 'id',
        Header: 'Id'
      },
      {
        accessor: 'alias',
        Header: 'Nome'
      },
      {
        accessor: 'slug',
        Header: 'Slug'
      },
      {
        accessor: 'uuid',
        Header: 'Uuid'
      },
      {
        accessor: '',
        Header: 'Ações',
        Cell: props => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                href="#"
                className="card-drop cursor-pointer"
                tag="div"
              >
                <i className="mdi mdi-pencil font-size-14 text-success me-1" />
                <span className="font-size-14 text-success text-normal">
                  Editar
                </span>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => handleCallModalAction('Profile', props)}
                  className="d-flex align-center"
                >
                  <i className="bx bx-user font-size-16 me-1" /> Perfil
                </DropdownItem>
                <DropdownItem
                  onClick={() => handleCallModalAction('Payment', props)}
                  className="d-flex align-center"
                >
                  <i className="bx bx-dollar-circle font-size-16 me-1" />{' '}
                  Pagamento
                </DropdownItem>
                <DropdownItem
                  onClick={() => handleCallModalAction('Lotteries', props)}
                  className="d-flex align-center"
                >
                  <i className="bx bx-donate-blood font-size-16 me-1" />{' '}
                  Loterias
                </DropdownItem>
                <DropdownItem
                  onClick={() => handleCallModalAction('Award', props)}
                  className="d-flex align-center"
                >
                  <i className="bx bx-award font-size-16 me-1" /> Premiação
                </DropdownItem>
                <DropdownItem
                  onClick={() => handleCallModalAction('Users', props)}
                  className="d-flex align-center"
                >
                  <i className="bx bx-group font-size-16 me-1" /> Usuários
                </DropdownItem>
                <DropdownItem
                  onClick={() => handleCallModalAction('Configs', props)}
                  className="d-flex align-center"
                >
                  <i className="bx bx-cog font-size-16 me-1" /> Configurações
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          )
        }
      }
    ]
  }, [handleCallModalAction])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    state: { globalFilter, pageSize, pageIndex },
    page,
    setGlobalFilter,
    gotoPage,
    nextPage,
    previousPage
  } = useTable(
    {
      columns,
      data: clients,
      initialState: {
        pageSize: 15
      }
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  return (
    <>
      <div className="page-content">
        <MetaTags>
          <title>Trivo | Painel</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="user" breadcrumbItem="Clientes" />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <CardTitle className="h4">Clientes</CardTitle>
                      <p className="card-title-desc">Tabela de clientes</p>
                    </Col>
                    <Col sm="8">
                      <div className="text-sm-end">
                        <Button
                          color="primary"
                          className="font-16 btn-block btn btn-primary"
                          onClick={() =>
                            handleCallModalAction('NewClient', null)
                          }
                        >
                          <i className="mdi mdi-plus-circle-outline me-1" />
                          Novo cliente
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col md="4">
                      <div className="search-box me-2 mb-2 d-inline-block">
                        <div className="position-relative">
                          <SearchBar
                            placeholder="Buscar"
                            onSearch={setGlobalFilter}
                            searchText={globalFilter}
                          />
                          <i className="bx bx-search-alt search-icon" />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <div className="table-responsive">
                    <table
                      className="table align-middle table-nowrap"
                      {...getTableProps()}
                    >
                      <thead>
                        {headerGroups.map((headerGroup, index) => (
                          <tr
                            key={index}
                            {...headerGroup.getHeaderGroupProps()}
                          >
                            {headerGroup.headers.map((column, index) => (
                              <th
                                key={index}
                                {...column.getHeaderProps(
                                  column.getSortByToggleProps()
                                )}
                              >
                                {column.render('Header')}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      {isLoading ? (
                        <div className="mh-20 border-none">
                          <Spinner size="sm" />
                        </div>
                      ) : (
                        <tbody {...getTableBodyProps()}>
                          {page.map((row, index) => {
                            prepareRow(row)
                            return (
                              <tr key={index} {...row.getRowProps()}>
                                {row.cells.map(cell => {
                                  return (
                                    <td key={index} {...cell.getCellProps()}>
                                      {cell.render('Cell')}
                                    </td>
                                  )
                                })}
                              </tr>
                            )
                          })}
                        </tbody>
                      )}
                    </table>
                  </div>
                  <div className="d-flex align-center">
                    <span>Total de {clients?.length} registros</span>
                    <Pagination
                      onNextPage={nextPage}
                      onPreviousPage={previousPage}
                      onChangePage={page => gotoPage(page)}
                      registersPerPage={pageSize}
                      totalPageCount={clients?.length}
                      currentPage={pageIndex + 1}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <ProfileModal
        client={client}
        isOpen={isProfileModalOpen}
        onToggle={() => handleCallModalAction('Profile', null)}
      />
      <PaymentModal
        client={client}
        isOpen={isPaymentModalOpen}
        onToggle={() => handleCallModalAction('Payment', null)}
      />
      <LotteriesModal
        client={client}
        isOpen={isLotteriesModalOpen}
        onToggle={() => handleCallModalAction('Lotteries', null)}
      />
      <AwardModal
        client={client}
        isOpen={isAwardModalOpen}
        onToggle={() => handleCallModalAction('Award', null)}
      />
      <UsersModal
        client={client}
        isOpen={isUsersModalOpen}
        onToggle={() => handleCallModalAction('Users', null)}
      />
      <NewClientModal
        isOpen={isNewClientModalOpen}
        onToggle={() => handleCallModalAction('NewClient', null)}
      />
      <ConfigsModal
        client={client}
        isOpen={isConfigsModalOpen}
        onToggle={() => handleCallModalAction('Configs', null)}
      />
    </>
  )
}
